export default "__VITE_ASSET__DnQDF_Zy__"